<template>
  <v-dialog
    :value="dialog"
    :max-width="600"
    persistent
    :retain-focus="false"
    scrollable
    class="p-sms-send-dialog"
    @keydown.esc="escape(closeDialog)"
    @click:outside="escape(closeDialog)"
    @keydown.enter="submit"
  >
    <v-card outlined>
      <v-card-title>
        {{ $t("sms.newSms") }}
        <p-btn-icon
          type="close"
          btn-class="mr-n3 ml-auto"
          tabindex="4"
          @click="escape(closeDialog)"
        ></p-btn-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form" @submit.stop.prevent>
        <v-container>
            <v-row class="pt-5">
              <v-col>
                <v-combobox
                  ref="destinations"
                  v-model="newSms.destinations"
                  :items="phoneContactsMobile"
                  :label="$t('sms.edit.to')"
                  :rules="rules.to"
                  item-value="contactId"
                  item-text="displayNameWithCompanyAndMobile"
                  prepend-icon="mdi-account-multiple-outline"
                  tabindex="1"
                  validate-on-blur
                  multiple
                  small-chips
                  deletable-chips
                  return-object
                  autofocus
                  clearable
                  @change="onDestinationsChange"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.displayNameWithCompanyAndMobile"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-text="item.phone"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-combobox>
                <v-textarea
                  v-model.trim="newSms.message"
                  :placeholder="$t('sms.edit.message')"
                  :rules="rules.message"
                  prepend-icon="mdi-text"
                  class="p-input-solo-filled"
                  tabindex="1"
                  clearable
                  validate-on-blur
                  solo
                  @input="onMessageInput"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-center">
        <v-btn text tabindex="3" @click="closeDialog">{{ $t("cancel") }}</v-btn>
        <v-btn
          text
          color="primary"
          tabindex="2"
          :disabled="!isModelChanged()"
          @click="submit"
          >{{ $t("sms.edit.send") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

import PBtnIcon from '@/components/PBtnIcon'

import snackbarMixin from '@/mixins/snackbar.mixin'
import dialogMixin from '@/mixins/dialog.mixin'
import validationMixin from '@/mixins/validation.mixin'
import unsavedChangesMixin from '@/mixins/unsavedChanges.mixin'


export default {
  components: {
    PBtnIcon
  },


  mixins: [
    snackbarMixin,
    dialogMixin,
    validationMixin,
    unsavedChangesMixin
  ],


  props: {
    sms: null,
    thread: null
  },


  data () {
    return {
      newSms: {},
      to: [],
      fullSms: {
        destinations: [],
        message: ''
      }
    }
  },


  computed: {
    ...mapGetters('contact', ['phoneContactsMobile']),

    rulesToApply () {
      const rule = this.rule

      return {
        to: [rule.required()],
        message: [rule.required()]
      }
    }
  },


  methods: {
    ...mapActions('sms', ['createSms', 'createThreadSms']),

    onDialogOpen () {
      this.initData()
      this.updateFullSms()
      this.initWatchedModel('fullSms')
      this.resetValidation()
    },

    initData () {
      this.newSms = {}
    },

    onDestinationsChange () {
      this.$refs.destinations.lazySearch = ''
      this.updateFullSms()
    },

    onMessageInput () {
      this.updateFullSms()
    },

    updateFullSms () {
      this.fullSms = {
        destinations: [],
        message: ''
      }

      if (this.newSms?.message) {
        this.fullSms.message = this.newSms.message
      }

      if (this.newSms?.destinations?.length) {
        this.fullSms.destinations = this.newSms.destinations.map(destination => {
          return {
            contactId: destination.contactId
              ? destination.contactId : this.phoneContacts?.find(item => item.phoneNumber === destination)
                ? this.phoneContacts?.find(item => item.phoneNumber === destination).contactId : null,
            phoneNumber: destination.phoneNumber ? destination.phoneNumber : destination
          }
        })
      }
    },


    async submit () {
      const valid = await this.validate(this.rulesToApply)
      if (!valid || !this.isModelChanged()) return

      try {
        await this.createSms(this.fullSms)
        this.closeDialog()
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    }
  }
}
</script>
